import { render, staticRenderFns } from "./DesignActions.vue?vue&type=template&id=48871ce3&"
import script from "./DesignActions.vue?vue&type=script&lang=js&"
export * from "./DesignActions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports